export default __webpack_public_path__ + "static/media/daily.cddc29c2.png";